import type { VoidFunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import Button from '../../../generic/Button';
import ModalEditDependency from '../../../modals/ModalEditDependency';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';

/**
 * IssueDetailsActionButtonEditPackage includes the button and the modal
 * for the Edit Package action button.
 */
const IssueDetailsActionButtonEditPackage: VoidFunctionComponent = () => {
  const { editPackageModal, isAnyModalOpen } = useIssueDetailsModals();
  const issueDetails = useSelector(IssuesV2Store.selectors.getIssueDetails);
  const parentRevisionLocator = useSelector(IssuesV2Store.selectors.getProjectLocatorFromScope);
  const dispatch = useDispatch();
  const onChange = () => dispatch(IssuesV2Store.actions.refetchIssueDetails());

  return (
    <>
      <Button
        type="secondary"
        size="medium"
        onClick={editPackageModal.onOpen}
        isDisabled={isAnyModalOpen}
      >
        Edit Package
      </Button>
      <ModalEditDependency
        show={editPackageModal.isOpen}
        onHide={editPackageModal.onClose}
        onChange={onChange}
        revisionLocator={issueDetails?.source.id}
        parentRevisionLocator={parentRevisionLocator}
      />
    </>
  );
};

export default IssueDetailsActionButtonEditPackage;
